import Cricket from'./Components/Cricketscore';
import './App.css';

function App() {
  return (
    <>
  <Cricket/>
    </>
  );
}

export default App;
